import { render } from "./ExampleDeviceScreenBussines.vue?vue&type=template&id=4c53049c&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenBussines.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenBussines.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenBussines.vue?vue&type=style&index=0&id=4c53049c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c53049c"]])

export default __exports__